import Vue from 'vue';
import Vuex from 'vuex';

import config from './modules/config';
import user from './modules/user';
import menu from './modules/menu';
import breadcrumbs from './modules/breadcrumbs';
import category from './modules/category';
import cart from './modules/cart';
import product from './modules/product';
import stores from './modules/stores';
import orders from './modules/orders';
import banners from './modules/banners';
import notifications from './modules/notifications';
import productGalleries from './modules/product-galleries';
import publications from './modules/publications';
import favorites from './modules/favorites';
import club from './modules/club';
import staticPages from './modules/static-pages';
import seo from './modules/seo';

Vue.use(Vuex);

// экспортируем функцию-фабрику для создания экземпляров нового стора
export function createStore () {
  return new Vuex.Store({
    // важно: состояние в модулях должно быть функцией, чтобы модуль мог инстанцироваться несколько раз
    modules: {
      config,
      user,
      menu,
      breadcrumbs,
      category,
      cart,
      product,
      stores,
      orders,
      banners,
      notifications,
      productGalleries,
      favorites,
      club,
      publications,
      staticPages,
      seo,
    }
  })
}
